import {
  takeEvery, takeLatest, select, all, put,
} from 'redux-saga/effects';

import {
  loginAction, resetPasswordAction, changePasswordAction, loadEmailParamsAction,
  createLoginSaga, createResetPasswordSaga, createChangePasswordSaga,

  AuthorizationApi, ReportParamsApi,
  refreshAccessToken,

  loadEmailParams,

  createEmailReportsSagas,
} from '@smorder/logic';

import {
  loadAreas as loadAreasAction,
  setFilterOption as setFilterOptionAction,
  setComparisonDateRange as setComparisonDateRangeAction,
  setDateRangeAction,
  requestSetDateRangeAction,
} from '../reducers/filter.reducers';

import {
  createNote as createNoteAction,
  loadNotes as loadNotesAction,
  deleteNote as deleteNoteAction,
} from '../reducers/note.reducers';

import {
  addMessage,
} from '../reducers/message.reducers';

import {
  loadLocationsAction,
  loadReportData as loadReportDataAction,
  selectLocationOnLoad as selectLocationOnLoadAction,
  selectReportOnLoad as selectReportOnLoadAction,
  selectReport as selectReportAction,
  selectLocation as selectLocationAction,
  selectReportByWidgetId as selectReportByWidgetIdAction,
  loadAllReportData as loadAllReportDataAction,
  loadParamsAction,
  setParamValueAction,
  loadCsvReportDataAction,
} from '../reducers/reports.reducers';

import { navigate } from '../reducers/navigator.reducers';

import loadAreas from './location.sagas';

import {
  createNote,
  loadNotes,
  deleteNote,
} from './note.sagas';

import {
  loadLocations,
  loadReportData,
  selectLocationOnLoad,
  selectReportOnLoad,
  setDateRangeOnSelectReport,
  loadTpsStatus,
  selectReportByWidgetId,
  loadAllReportData,
  putLoadAllReportDataAction,
  loadReportDataForComparisonId,
  selectReportBasedOnLocation,
  loadParams,
  putLoadParams,
  setParams,
  setDateRange,
  loadCsvReportData,
} from './reports.sagas';

import {
  LocationApi,
  NoteApi,
  ReportsApi,
} from '../api';

import config from '../../run-config';
import { allowedRoles } from '../models';

import takeLatestPerProps from '../util/take-latest-per-props';

const login = createLoginSaga(allowedRoles, !config.onPremiseMode && [put(navigate({ route: '/' }))]);
const resetPassword = createResetPasswordSaga([
  put(navigate({
    route: '/forgotPassword/success',
  })),
]);
const changePassword = createChangePasswordSaga(
  [put(addMessage({ message: 'Passwort erfolgreich geändert', type: 'passwordChanged', level: 'info' }))],
  [put(addMessage({ message: 'Passwort konnte nicht geändert werden', type: 'passwordChanged', level: 'error' }))],
);

export default function* rootSaga() {
  let authApi = null;

  function* tokenProvider() {
    const { accessToken, refreshToken, expiresAt, expiresIn } = yield select(state => state.authentication);
    return {
      accessToken,
      refreshToken,
      expiresIn,
      expiresAt,
    };
  }

  function* tokenRefreshTask() {
    return yield refreshAccessToken(authApi);
  }

  function optionProvider() {
    return {
      tokenRefreshTask,
      tokenProvider,
    };
  }


  authApi = new AuthorizationApi(config.apiHost, optionProvider, null, config.brand, 'reports');
  const locationApi = new LocationApi(config.apiHost, optionProvider, null, config.brand);
  const noteApi = new NoteApi(config.apiHost, optionProvider, null, config.brand);
  const reportsApi = new ReportsApi(config.reportsHost, optionProvider, null, config.brand);

  const reportParamsApi = new ReportParamsApi(config.reportsHost, optionProvider, null, config.brand);


  yield all([
    takeEvery(loginAction.INIT, login, authApi),
    takeEvery(resetPasswordAction.INIT, resetPassword, authApi),
    takeEvery(changePasswordAction.INIT, changePassword, authApi),

    takeEvery(loadAreasAction, loadAreas, locationApi),

    takeLatest(loadLocationsAction.INIT, loadLocations, reportsApi),
    takeLatest(selectLocationOnLoadAction, selectLocationOnLoad),
    takeLatest(selectLocationAction, loadTpsStatus, reportsApi),
    takeLatest(selectLocationAction, selectReportBasedOnLocation),

    takeEvery(createNoteAction, createNote, noteApi),
    takeLatest(loadNotesAction, loadNotes, noteApi),
    takeEvery(deleteNoteAction, deleteNote, noteApi),

    takeLatest(selectReportAction, setDateRangeOnSelectReport),
    takeLatest(selectReportOnLoadAction, selectReportOnLoad),
    takeEvery(selectReportByWidgetIdAction, selectReportByWidgetId),
    takeLatest(loadAllReportDataAction, loadAllReportData),
    takeLatestPerProps(['widgetId', 'reportDataId'], loadReportDataAction, loadReportData, reportsApi),
    takeLatest(selectReportAction, loadAllReportData),
    takeLatest(setFilterOptionAction, putLoadAllReportDataAction),
    takeEvery(setComparisonDateRangeAction, loadReportDataForComparisonId),
    takeEvery(setDateRangeAction, putLoadAllReportDataAction),
    takeLatest(selectReportAction, putLoadParams),
    takeLatest(setDateRangeAction, putLoadAllReportDataAction),
    takeLatest(setParamValueAction, putLoadAllReportDataAction),
    takeLatest(setParamValueAction, setParams),
    takeLatest(loadCsvReportDataAction.INIT, loadCsvReportData, reportsApi),

    takeLatest(requestSetDateRangeAction, setDateRange),

    takeLatest(loadParamsAction.INIT, loadParams, reportParamsApi),

    takeEvery(loadEmailParamsAction.INIT, loadEmailParams, reportParamsApi),
    ...createEmailReportsSagas(config.apiHost, optionProvider, null, config.brand),
  ]);
}
